// CAPICOM constants
var CAPICOM_CURRENT_USER_STORE = 2;
var CAPICOM_LOCAL_MACHINE_STORE = 1;
var CAPICOM_MY_STORE = "My";
var CAPICOM_STORE_OPEN_READ_ONLY = 0;
var CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
var CAPICOM_CERTIFICATE_FIND_EXTENDED_PROPERTY = 6;
var CAPICOM_CERTIFICATE_FIND_TIME_VALID = 9;
var CAPICOM_CERTIFICATE_FIND_KEY_USAGE = 12;
var CAPICOM_DIGITAL_SIGNATURE_KEY_USAGE = 128;
var CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
var CAPICOM_INFO_SUBJECT_SIMPLE_NAME = 0;
var CAPICOM_ENCODE_BASE64 = 0;
var CAPICOM_E_CANCELLED = -2138568446;
var CERT_KEY_SPEC_PROP_ID = 6;
var CAPICOM_VERIFY_SIGNATURE_ONLY = 0;
var CAPICOM_CHECK_NONE = 0
var CAPICOM_CHECK_TRUSTED_ROOT = 1
var CAPICOM_CHECK_TIME_VALIDITY = 2
var CAPICOM_CHECK_SIGNATURE_VALIDITY = 4
var CAPICOM_CHECK_ONLINE_REVOCATION_STATUS = 8
var CAPICOM_CHECK_OFFLINE_REVOCATION_STATUS = 16

function signTheString(src) {
    if (typeof String.prototype.trim === 'function') {
        if (src.trim() === "") {
            cryo_alert(mlMsgDigitalCertificateFormEmpty);
        }
    } else {
        if (src === "") {
            cryo_alert(mlMsgDigitalCertificateFormEmpty);
        }
    }

    try {
        // instantiate the CAPICOM objects
        var signedData = new ActiveXObject("CAPICOM.SignedData");

        // Set the data that we want to sign
        signedData.Content = src;
        var signer = findCertificateByHash();

        // Do the Sign operation
        var signed = signedData.Sign(signer, true);
        return signed;
    } catch (e) {
        cryo_alert(mlMsgDigitalSignError + e.description);
    }

    return "";
}

function findCertificateByHash() {
    try {
        // instantiate the CAPICOM objects
        var store = new ActiveXObject("CAPICOM.Store");
        var certs = new ActiveXObject("CAPICOM.Certificates");
        var cert = new ActiveXObject("CAPICOM.Certificate");
        var signer = new ActiveXObject("CAPICOM.Signer");
        var signerCert = null;

        // open the current users personal certificate store
        store.Open(CAPICOM_CURRENT_USER_STORE, CAPICOM_MY_STORE, CAPICOM_STORE_OPEN_READ_ONLY);
        for (var i = 1; i < store.Certificates.Count + 1; i++) {
            cert = store.Certificates.Item(i);
            if (cert.GetInfo(CAPICOM_INFO_SUBJECT_SIMPLE_NAME).length > 0) {
                certs.Add(cert);
            }
        }

        // open the local machine certificate store
        store.Open(CAPICOM_LOCAL_MACHINE_STORE, CAPICOM_MY_STORE, CAPICOM_STORE_OPEN_READ_ONLY);
        for (var i = 1; i < store.Certificates.Count + 1; i++) {
            cert = store.Certificates.Item(i);
            if (cert.GetInfo(CAPICOM_INFO_SUBJECT_SIMPLE_NAME).length > 0) {
                certs.Add(cert);
            }
        }

        if (certs.Count === 0) {
            // no certificate found
            cryo_alert(mlMsgNoCertificatesFound);
            return false;
        } else {
            signerCert = certs.Select();
        }

        if (isValid(signerCert.Item(1)) === false) {
            cryo_alert(mlMsgSelectedCertificateIsInvalid);
            return false;
        }

        signer.Certificate = signerCert.Item(1);

        return signer;
    } catch (e) {
        cryo_alert(mlMsgCapicomNotFound);
        return false;
    }
}

function isValid(certificate) {
    certificate.IsValid().CheckFlag = (CAPICOM_CHECK_TRUSTED_ROOT ||
        CAPICOM_CHECK_TIME_VALIDITY ||
        CAPICOM_CHECK_SIGNATURE_VALIDITY ||
        CAPICOM_CHECK_ONLINE_REVOCATION_STATUS);

    return certificate.IsValid().Result;
}

function verify(dataToVerify, signedData) {
    var verified = false;
    var certificatesInfo = '';
    try {
        // instantiate the CAPICOM objects
        var signed = new ActiveXObject("CAPICOM.SignedData");
        var cert = new ActiveXObject("CAPICOM.Certificate");

        // Set the data that we want to sign
        signed.Content = dataToVerify;
        // verify signature
        verified = signed.Verify(signedData, true, CAPICOM_VERIFY_SIGNATURE_ONLY);

        for (var i = signed.Certificates.Count; i > 0; i--) {
            cert = signed.Certificates.Item(i);
            certificatesInfo += '<li>' + cert.GetInfo(CAPICOM_INFO_SUBJECT_SIMPLE_NAME) + '</li>';
            if (cert !== undefined) {
                break;
            }
        }

        verified = (verified === undefined);

        if (verified && certificatesInfo !== '') {
            cert.Display();
        }
    } catch (e) {
        if (e.number != CAPICOM_E_CANCELLED) {
            cryo_alert(mlMsgDigitalSignError + e.description);
        }
    }
    return verified;
}

function viewSignature(code) {
    var signatureFormatted;

    signatureFormatted = document.getElementById("divSignatureFormatted_" + code).innerHTML;

    $('#pDigitalCertificateInfo').html(signatureFormatted);

    $('#pDigitalCertificateInfo').attr('data-code', code);
    $.colorbox({ inline: true, href: "#boxSignature", width: "50%" });
}

function viewElectronicSignature(code) {
    var signatureFormatted;

    signatureFormatted = document.getElementById("divSignatureFormatted_" + code).innerHTML;

    $('#pElectronicSignatureInfo').html(signatureFormatted);

    $('#pElectronicSignatureInfo').attr('data-code', code);
    $.colorbox({ inline: true, href: "#boxElectronicSignature", width: "70%", height: "85%" });
}

function openCloseCertificateData(sender) {
    var $table;
    var signature, content, code;

    code = $('#pDigitalCertificateInfo').attr('data-code');

    signature = document.getElementById("divSignature_" + code).innerText;
    content = document.getElementById("divContentData_" + code).innerHTML;
    content = content.replace("#ft;", "<");
    content = content.replace("#lt;", ">");

    if ('ActiveXObject' in window) {
        // IE
        verify(content, signature);
    } else {
        $table = $(sender).parent().find('#certificate-data-table');

        $table.toggleClass('hide');

        $(sender).find('em').text($table.hasClass('hide') ? '+' : '-');
    }
}